import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const CustomerPersonaPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "CustomerPersonaPopup" */ './Container'),
  'popup'
);
